<template>
  <div id="offer-timer" class="timer__container">
    <div class="timer__content">
      <div v-if="timer" class="timer__gift">
        <img :src="mediaBaseUrl + 'subscription/gift.png'" alt="gift">

        <div class="gift__content">
          <p>We have a gift for you!</p>
          <p class="pick-up">Hurry up and pick up your gift</p>
        </div>
      </div>
      <div v-else class="timeout-gift">
        <div class="group">
          <img :src="mediaBaseUrl + 'subscription/gift.png'" alt="gift">
          <p>Your gift</p>
        </div>

        <p>+</p>

        <div class="group">
          <img :src="mediaBaseUrl + 'subscription/discount.png'" alt="gift">
          <p>-82% off</p>
        </div>
      </div>

      <div v-if="timer" class="timer">
        <div class="timer__block">
          <span class="timer__number">{{formatTime(minutes)}}</span>
          <span class="timer__unit">minutes</span>
        </div>
        <div class="timer__block">
          <span class="timer__number">{{formatTime(seconds)}}</span>
          <span class="timer__unit">seconds</span>
        </div>
      </div>
    </div>

    <router-link to="#plan2">
      <custom-button :animation="true" :primary="true" :light="true">
        Get my gift
      </custom-button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Timer",
  inject: ["mediaBaseUrl"],

  props: {
    active: Boolean,
    startTimeStamp: {
      type: Number,
      default: Date.now(),
    },
    expires: {
      type: Number,
      default: 300, // seconds
    },
    speed: {
      type: Number,
      default: 1000, // milliseconds
    },
  },

  data() {
    return {
      currentTime: null,
      timer: null,
    };
  },

  mounted() {
    const timer = localStorage.getItem("timer-end");

    if (this.isNumber(timer)) {
      this.expires = +timer;
    } else if (timer === 'null') {
      this.expires = 0;
    }
    this.timer = setTimeout(this.countdown, this.speed);
  },

  computed: {
    endTimeStamp() {
      return new Date(this.startTimeStamp + this.expires * 1000).getTime();
    },
    seconds() {
      return Math.floor((this.currentTime / 1000) % 60);
    },
    minutes() {
      return Math.floor((this.currentTime / 1000 / 60) % 60);
    },
    hours() {
      return Math.floor((this.currentTime / (1000 * 60 * 60)) % 24);
    },
    days() {
      return Math.floor(this.currentTime / (1000 * 60 * 60 * 24));
    },
  },

  methods: {
    isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    formatTime(value) {
      if (value < 10) {
        return "0" + value;
      }
      return value;
    },
    countdown() {
      this.currentTime = this.endTimeStamp - Date.now();
      if (this.currentTime > 0) {
        this.timer = setTimeout(this.countdown, this.speed);
        localStorage.setItem("timer-end", Math.round(this.currentTime / 1000));
      } else {
        this.currentTime = null;
        localStorage.setItem("timer-end", null);
        clearTimeout(this.timer);
        this.timer = null;
        this.$emit("timeout")
      }
    }
  },

  beforeDestroy() {
    clearTimeout(this.timer);
    this.timer = null;
  },
}
</script>

<style lang="sass" scoped>
@import '../../../sass/variables'

#offer-timer
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: center
  width: 100%

  .timeout-gift
    display: flex
    flex-direction: column
    align-items: flex-start
    gap: 3px

    & > p
      display: none

    .group
      display: flex
      align-items: center
      gap: 8px

      &:last-child
        margin-left: 36px

    p
      color: rgba(255, 255, 255, 1)
      font-size: 20px
      line-height: 30px
      font-weight: 500
      text-align: left

    img
      width: 26px
      height: 26px

    @media screen and (min-width: $lg)
      flex-direction: row
      align-items: center
      gap: 29px

      & > p
        display: block
        font-size: 32px
        line-height: 48px

      .group
        gap: 13px

        p
          font-size: 28px
          line-height: 42px

        &:last-child
          margin-left: 0

      img
        width: 48px
        height: 48px

  .button
    width: fit-content
    padding: 12px 32px

  .timer__content
    display: flex
    align-items: center

    .timer
      display: flex
      align-items: center
      gap: 6px

    .timer__block
      display: flex
      flex-direction: column
      align-items: center
      background: rgba(253, 253, 253, 1)
      border-radius: 6px
      padding: 3px

      .timer__number
        color: rgba(42, 42, 42, 1)
        font-size: 24px
        line-height: 28px
        font-weight: 500
        text-align: center

      .timer__unit
        color: rgba(109, 109, 109, 1)
        font-size: 10px
        line-height: 15px
        text-align: center

  .timer__gift
    display: none
    align-items: center
    margin-right: 22px

    img
      margin-right: 12px

    .gift__content
      p
        color: rgba(255, 255, 255, 1)
        font-size: 24px
        line-height: 28px
        font-weight: 500
        text-align: left

      .pick-up
        font-size: 16px
        line-height: 24px

    @media screen and (min-width: $lg)
      display: flex
</style>
